@if (product) {
  <rt-product-order-header [breadcrumbs]="breadcrumbs" [header]="headingText" margin-bottom-large />

  <rt-product-order-summary
    [product]="product"
    [price]="price"
    [paymentInterval]="interval"
    [slots]="slots"
    [addons]="subscription!.addons"
    [companyName]="companyName"
    [billingEstimate]="billingEstimate"
    [billingCountry]="billingInformation?.countryCode"
    [style.display]="'block'"
    margin-bottom
  />

  <rt-box variant="vertical">
    @if (hasCreditCardData) {
      <rt-box
        (click)="selectFlow('reuse')"
        [class.clickable]="flow !== 'reuse'"
        [class.background-light-blue]="flow === 'reuse'"
        variant="vertical clickable"
        margin-bottom
      >
        <rt-radio [checked]="flow === 'reuse'" [style.pointerEvents]="'none'">
          {{ 'app.pricing.product_order.use_existing_method' | translate }}
        </rt-radio>

        <rt-credit-card
          [cardType]="billingInformation.stripeCardType!"
          [cardLast4Digits]="billingInformation.stripeCardLast4!"
          [cardExpirationDate]="billingInformation.stripeCardExpiration!"
        />
      </rt-box>

      <rt-box
        variant="vertical"
        [class.clickable]="flow !== 'change'"
        [class.background-light-blue]="flow === 'change'"
        (click)="selectFlow('change')"
      >
        <rt-radio [checked]="flow === 'change'" [style.pointerEvents]="'none'">
          {{ 'app.pricing.product_order.new_payment_method' | translate }}
        </rt-radio>
        @if (flow === 'change') {
          <ng-container *ngTemplateOutlet="pristineCard" />
        }
      </rt-box>
    } @else {
      <rt-stripe-card (changed)="cardFormChange($event)" />
    }

    @if (errorMessage) {
      <rt-message variant="context-error" margin-top>{{ errorMessage }}</rt-message>
    }

    <rt-divider margin-tb />
    <ng-container *ngTemplateOutlet="termsAndConditions" />
  </rt-box>

  <ng-template #termsAndConditions>
    @if (manualChangeMode) {
      <p class="text-small-x" margin-bottom-small>
        <span [innerHTML]="manualTermsGeneral"></span>{{ ' ' }}
        @if (!additionalTermsExpanded()) {
          <a (click)="additionalTermsExpanded.set(true)">{{
            'app.common.show_more' | translate
          }}</a>
        } @else {
          {{
            'app.pricing.product_order.payment_footer_manual_terms.general_expanded'
              | translate: { companyId: companyId }
          }}
        }
      </p>
      @if (additionalTermsExpanded()) {
        <p class="text-small-x" margin-bottom-small>
          {{ additionalTermsText }}
        </p>
      }
    }
    @for (checkbox of confirmations; track trackByIndex($index, checkbox)) {
      <rt-checkbox
        [attr.margin-bottom-small]="!$last ? true : null"
        [checked]="checkbox.value"
        (valueChange)="toggleCheckbox($index)"
        ><span [innerHTML]="checkbox.label"></span
      ></rt-checkbox>
    }
  </ng-template>

  <ng-template #pristineCard>
    <rt-stripe-card (changed)="cardFormChange($event)" />
  </ng-template>

  <div layout-horizontal margin-top layout-justify-flex-end>
    <rt-button (click)="back()" variant="plain">
      {{ 'app.common.go_back' | translate }}
    </rt-button>
    @if (payLaterEnabled) {
      <rt-button
        (click)="next(true)"
        [disabled]="!isConfirmed || proceeding"
        [loading]="proceeding"
        variant="primary"
        margin-left-small
      >
        {{ altCtaBtnText }}
      </rt-button>
    }
    <rt-button
      (click)="next()"
      [disabled]="!isValid || proceeding"
      [loading]="proceeding"
      variant="primary"
      margin-left-small
    >
      {{ ctaBtnText }}
    </rt-button>
  </div>
} @else {
  <rt-spinner />
}

<ng-template #loading>
  <rt-spinner />
</ng-template>
